<template>
  <div>
    <VCheckbox
      v-model="emailCheckbox"
      hide-details
      :label="$t('sendMessage')"
    />
    <VTextarea
      v-model="emailMessage"
      :disabled="!emailCheckbox"
      outlined
      hide-details
      class="mt-2 mb-4 white"
    />
    <VTextField
      v-model="note"
      :label="$t('note')"
      hide-details
      outlined
      autocomplete="off"
      class="mb-6"
    />

    <VSheet
      color="yellow lighten-4"
      tile
      outlined
      class="pa-4 mb-6"
    >
      {{ $t('noteTip') }}
    </VSheet>

    <VAlert v-if="errorMessage" type="error">
      {{ errorMessage }}
    </VAlert>

    <div class="d-flex justify-start">
      <VBtn
        :disabled="!(emailCheckbox && emailMessage) && !note"
        :loading="loading"
        height="40"
        color="error"
        class="ma-2"
        @click="submit"
      >
        {{ $t('send') }}
      </VBtn>
      <VBtn
        outlined
        height="40"
        color="grey"
        class="ma-2"
        @click="reset"
      >
        {{ $t('cancel') }}
      </VBtn>
    </div>
  </div>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin';
import RecaptchaMixin from '../mixins/RecaptchaMixin';
import Candidate from '../orm/models/Candidate/Candidate';
import CandidateLog from '../orm/models/Candidate/CandidateLog';
import { candidateLogType } from '../enums';

export default {
  name: 'CandidateRejectNotificationForm',
  mixins: [ValidationMixin, RecaptchaMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    emailText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emailCheckbox: false,
      emailMessage: this.emailText,
      note: null,
    };
  },
  methods: {
    reset() {
      this.emailCheckbox = false;
      this.emailMessage = null;
      this.note = null;
      this.errorMessage = null;

      this.$emit('cancel');
    },
    async submit() {
      await this.withValidationHandling(async () => {
        const recaptchaToken = await this.getRecaptchaToken('candidateContact');

        if (this.emailCheckbox && this.emailMessage) {
          await Candidate.api().notify(this.candidate.id, {
            mail: this.emailMessage,
            recaptchaToken,
          });
        }
        if (this.note) {
          await CandidateLog.api().store(this.candidate.id, {
            eventType: candidateLogType.DECLINED_REASON,
            comment: this.note,
          });
        }

        this.$toast.success(this.$t('messageSent'));
        CandidateLog.api().fetchAllByCandidateId(this.candidate.id);
        this.reset();
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  sendMessage: Send message
  messageSent: Message sent
  note: Note with a reason for rejection (visible only to you)
  noteTip: Candidate won't see this note. It will be visible only to you.
  send: Send
  cancel: Clear
</i18n>

<i18n locale="ru" lang="yaml">
  sendMessage: Отправить сообщение
  messageSent: Сообщение отправлено
  note: Пометка с причиной отказа (для себя)
  noteTip: >-
    Кандидат не увидит эту пометку. Она нужна для того, чтобы в будущем было проще
    вспомнить, почему вы решили отказать.
  send: Отправить
  cancel: Очистить
</i18n>
